<input pInputText #appGmAutocomplete class="controls" type="text" style="height: 29px;" (keyup)="onValidate($event)" (blur)="onValidate($event)" [disabled]="disabled"/>
<!-- <small class="p-invalid">{{ ErrorMessageSetLocation }}</small> -->
